import React, { useState } from 'react';
import { Pie } from 'react-chartjs-2';
import 'chart.js/auto';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Card, Row, Col, Table } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserGraduate, faLaptopCode } from '@fortawesome/free-solid-svg-icons';
import { FaCaretDown, FaCaretUp } from 'react-icons/fa';
import data from '../graphdata.json';

const colors = [
  'rgba(0, 123, 255, 0.6)',
  'rgba(23, 162, 184, 0.6)',
  'rgba(40, 167, 69, 0.6)',
  'rgba(255, 80, 0, 0.6)',
  'rgba(156, 204, 101, 0.6)',
  'rgba(255, 161, 0, 0.6)',
  'rgba(31, 58, 147, 0.6)',
  'rgba(102, 51, 153, 0.6)',
  'rgba(64, 87, 135, 0.6)',
  'rgba(220, 53, 69, 0.6)',
  'rgba(25, 135, 84, 0.6)',
  'rgba(249, 168, 37, 0.6)',
  'rgba(15, 107, 135, 0.6)',
  'rgba(138, 141, 144, 0.6)',
];

const PlacementsPieChart = () => {
  const [selectedYear, setSelectedYear] = useState(Math.max(...data.map(item => item.year)));

  // Filter data based on selected year
  const filteredData = data.filter(item => item.year === selectedYear && item.placements !== 0);

  // Calculate total number of placements
  const totalPlacements = filteredData.reduce((sum, item) => sum + item.placements, 0);

  // Calculate total number of students appeared
  const totalStudentsAppeared = filteredData.reduce((sum, item) => sum + item.Total_Students_Appeared, 0);

  // Generate labels for the pie chart
  const chartLabels = filteredData.map(item => item.companyName);

  const lastLineText = filteredData[0].lastLineText;

  console.log(lastLineText);

  // Pie chart data
  const chartData = {
    labels: chartLabels,
    datasets: [
      {
        data: filteredData.map(item => item.placements),
        backgroundColor: colors.slice(0, chartLabels.length),
      },
    ],
  };

  // Handle year change
  const handleYearChange = event => {
    setSelectedYear(parseInt(event.target.value));
  };

  // Merge cells using rowspan
  const mergeCells = (columnData) => {
    const mergedCells = [];
    let prevValue = null;
    let rowspanCount = 0;

    for (let i = 0; i < columnData.length; i++) {
      const currentValue = columnData[i];

      if (currentValue === prevValue) {
        rowspanCount++;
      } else {
        if (prevValue !== null) {
          mergedCells.push({
            value: prevValue,
            rowspan: rowspanCount,
          });
        }
        prevValue = currentValue;
        rowspanCount = 1;
      }

      if (i === columnData.length - 1) {
        mergedCells.push({
          value: currentValue,
          rowspan: rowspanCount,
        });
      }
    }

    return mergedCells;
  };

  // Merge cells for Highest Package column
  const mergedHighestPackage = mergeCells(filteredData.map(item => item.HighestPkg));

  // Merge cells for Average Package column
  const mergedAveragePackage = mergeCells(filteredData.map(item => item.AvgPkg));

  

  return (
    <div className="container-fluid" style={{ overflowY: 'auto', maxHeight: 'calc(100vh)' }}>
      <div className="d-flex justify-content-center align-items-center">
        <label htmlFor="yearSelect" style={{ marginRight: '10px', whiteSpace: 'nowrap' }}>Select Year:</label>
        <div style={{ position: 'relative' }}>
          <select
            id="yearSelect"
            className="form-control"
            style={{ width: '100px' }}
            value={selectedYear}
            onChange={handleYearChange}
          >
            {Array.from(new Set(data.map(item => item.year))).sort((a, b) => b - a).map(year => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </select>
          <FaCaretDown style={{ position: 'absolute', top: '60%', right: '10px', transform: 'translateY(-50%)' }} />
          <FaCaretUp style={{ position: 'absolute', top: '40%', right: '10px', transform: 'translateY(-50%)' }} />
        </div>
      </div>
      <div className="chart-container" style={{ width: '100%', maxWidth: '600px', height: '500px', margin: '0 auto' }}>
        <Pie data={chartData} options={{
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            title: {
              display: true,
              text: 'Placement Data Year wise',
              font: {
                weight: 'bold'
              }
            },
            tooltip: {
              callbacks: {
                label: (context) => {
                  const label = chartLabels[context.dataIndex];
                  const value = filteredData[context.dataIndex].placements;
                  return `${label}: ${value}`;
                }
              }
            }
          }
        }} />
      </div>
      <Row className="justify-content-center align-items-center">
        <Col xs={12} md={6} lg={4} className="mb-3">
          <Card className="h-100">
            <Card.Body className="d-flex flex-column justify-content-center align-items-center">
              <FontAwesomeIcon icon={faLaptopCode} size="lg" className="mb-3" />
              <Card.Title style={{ margin: '0', textAlign: 'center' }}>Total Students Participated/Eligible: {totalStudentsAppeared}</Card.Title>
            </Card.Body>
          </Card>
        </Col>
        <Col xs={12} md={6} lg={4} className="mb-3">
          <Card className="h-100">
            <Card.Body className="d-flex flex-column justify-content-center align-items-center">
              <FontAwesomeIcon icon={faUserGraduate} size="lg" className="mb-3" />
              <Card.Title style={{ margin: '0', textAlign: 'center' }}>Total Offers: {totalPlacements}</Card.Title>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Table striped bordered hover style={{ width: '100%', margin: '0 auto' }}>
        <thead>
          <tr>
            <th style={{ backgroundColor: '#000080', color: 'white' }}>Serial No.</th>
            <th style={{ backgroundColor: '#000080', color: 'white' }}>Company Name</th>
            <th style={{ backgroundColor: '#000080', color: 'white' }}>Number of Placements</th>
            <th style={{ backgroundColor: '#000080', color: 'white' }}>Highest Package</th>
            <th style={{ backgroundColor: '#000080', color: 'white' }}>Average Package</th>
          </tr>
        </thead>
        <tbody>
          {filteredData.map((item, index) => (
            <tr key={item.companyName}>
              <td>{index + 1}</td>
              <td>{item.companyName}</td>
              <td>{item.placements}</td>
              {index === 0 && (
                <>
                  <td className='text-center' rowSpan={mergedHighestPackage[0].rowspan} style={{ verticalAlign: 'middle' }}>{mergedHighestPackage[0].value}</td>
                  <td className='text-center' rowSpan={mergedAveragePackage[0].rowspan} style={{ verticalAlign: 'middle' }}>{mergedAveragePackage[0].value}</td>
                </>
              )}
              {index > 0 && (
                <>
                  {mergedHighestPackage[index] && <td className='text-center' style={{ verticalAlign: 'middle' }}>{mergedHighestPackage[index].value}</td>}
                  {mergedAveragePackage[index] && <td className='text-center' style={{ verticalAlign: 'middle' }}>{mergedAveragePackage[index].value}</td>}
                </>
              )}
            </tr>
          ))}
        </tbody>
        <tbody>
          <tr className="text-center"><td colSpan={5}>{lastLineText}</td></tr>
        </tbody>
      </Table>
    </div>
  );
};

export default PlacementsPieChart;
